import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import { getPermissions } from "../rbac/hasAccess";

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Divider,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const RequirementView = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);

  const [inputStates, setInputStates] = useState({});
  const [subtypesData, setSubtypesData] = useState([]);

  const pdfRef = useRef();

  const fetchRequirementDetails = async () => {
    try {
      const [requirement] = await fetchQuery(
        `SELECT r.*, jr.jobNumber AS jobNumber FROM requirements r LEFT JOIN jobRegister jr ON r.jobId = jr.id WHERE r.id = ${params.id}`,
      );
      setInputStates(requirement || {});
    } catch (error) {
      console.error("Error fetching Requirement data:", error);
      toast.error("Failed to load requirement details");
    }
  };

  const fetchSubtypesDetails = async () => {
    try {
      const subtypes = await fetchQuery(
        `SELECT * FROM requirementPrices WHERE status = 1 AND requirementId = ${params.id}`,
      );
      setSubtypesData(subtypes || []);
    } catch (error) {
      console.error("Error fetching Subtypes data:", error);
      toast.error("Failed to load price details");
    }
  };

  useEffect(() => {
    if (params.id && params.id !== "0") {
      fetchRequirementDetails();
      fetchSubtypesDetails();
    }
  }, [params.id]);

  const totalAmount = subtypesData.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0,
  );

  const handleDownloadPDF = async () => {
    const element = pdfRef.current;
    if (!element) return;

    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
    pdf.save("Payment_Authorization_Sheet.pdf");
  };

  return (
    <Box p={3}>
      {/* Download Button */}
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          variant="contained"
          startIcon={<DownloadIcon />}
          onClick={handleDownloadPDF}
          disabled={inputStates?.approveStatus !== 1}
        >
          Download PDF
        </Button>
      </Box>

      {/* Printable Area */}
      <Box
        ref={pdfRef}
        sx={{
          border: "1px solid #e0e0e0",
          p: 5,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h5" align="center" fontWeight="bold">
          Internal Workflow System
        </Typography>
        <Typography variant="subtitle1" align="center" color="text.secondary">
          Payment Authorization Sheet
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* Header Details */}
        <Box
          display="flex"
          justifyContent="space-between"
          mb={2}
          //  paddingLeft={10} paddingRight={10}
        >
          <Box>
            <Typography>
              <b>ID:</b> {inputStates.id}
            </Typography>
            <Typography>
              <b>Type:</b> {inputStates.requirmentType}
            </Typography>
            <Typography>
              <b>Job Number:</b> {inputStates.jobNumber}
            </Typography>
            <Typography>
              <b>Priority:</b> {inputStates.priority}
            </Typography>
          </Box>

          <Box>
            <Typography>
              <b>Department:</b> {inputStates.department}
            </Typography>
            <Typography>
              <b>Date:</b>{" "}
              {inputStates.date
                ? new Date(inputStates.date).toLocaleDateString("en-GB")
                : "-"}
            </Typography>

            <Typography>
              <b>Status:</b>{" "}
              {inputStates?.l1Status === 2 ||
              inputStates?.hodStatus === 2 ||
              inputStates?.h1Status === 2 ||
              inputStates?.h2Status === 2
                ? "Rejected"
                : inputStates?.h2Status === 1
                  ? "Approved"
                  : "Pending"}
            </Typography>
          </Box>
        </Box>

        {/* Amount Table */}
        <Table sx={{ border: "1px solid #e0e0e0" }}>
          <TableHead sx={{ backgroundColor: "#f9fafb" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Description</TableCell>
              <TableCell sx={{ fontWeight: "bold" }} align="right">
                Amount
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {subtypesData.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.description}</TableCell>
                <TableCell align="right">
                  ₹{Number(row.amount).toFixed(2)}
                </TableCell>
              </TableRow>
            ))}

            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "#5b6cff" }}>
                Total Amount
              </TableCell>
              <TableCell
                align="right"
                sx={{ fontWeight: "bold", color: "#5b6cff" }}
              >
                ₹{totalAmount.toFixed(2)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default RequirementView;
